import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Container,
  Title,
  Text,
  Image,
} from './Modal.styled';
import modalImage from '../../assets/images/modalImage.webp';

const Modal = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <div>
        <Title>{t('attention')}</Title>
        <Text>{t('troublesWithSendingMessage')}</Text>
      </div>
      <Image src={modalImage} alt='modal image'></Image>
    </Container>
  );
};

export default Modal;
